import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function RedirectToHomeEditModal(props) {
    const {open }  = props
    const handleRedirect = ()=>{
        window.location.href = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`;

    }
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600 }}>
                {"Registration Closed"}
            </DialogTitle>

            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{ fontSize: "16px", lineHeight: 1.6 }}
                >
                    The registration for the selected course is currently closed. Please check back later or explore other available courses on our platform.
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ padding: "16px" }}>
                <Button
                    variant="outlined"
                    onClick={handleRedirect}
                    color="primary"
                    autoFocus
                    sx={{ textTransform: "none" }}
                >
                    Redirect to Home
                </Button>
            </DialogActions>
        </Dialog>

    )
}